// extracted by mini-css-extract-plugin
export default {"itemClassName":"SelectionLearnTriautoContent_itemClassName__zoNfL"};